import { DbCustomerLotteryFilters } from "./db-customer-lottery-filter";
import { DbCustomerLotteryBet, DbCustomerLotteryBets, DbTaskCategoryStatus } from "./db-customer-lottery-bet";
import { DbObjectBase } from './db-object-base';
import { Lottery, CustomerLottery } from '../../_shared/lottoloca-commom/lottery-modex';
import { ICollectionReference } from '../database-cast/IDatabase';
import { DbCustomerLotteryFiltersParams } from './db-customer-lotery-filters-params';
import { DbCustomerLotteryLab } from "./DbCustomerLotteryLab";
import { DbCustomerLotteryFilterGroups } from "./db-customer-lottery-filter-groups";



export class DbTaskCategory extends DbObjectBase<any> {

  constructor(category: string, collection: ICollectionReference) {
    super(category, collection);
    //  this._docReference = collection.doc(category);
  }


  getStatus(status: string): DbTaskCategoryStatus {
    return new DbTaskCategoryStatus(this._docReference.collection(status))
  }


}

export class DbCustomerLottery extends DbObjectBase<CustomerLottery> {



  //   private _docReference: IDocumentReference;

  constructor(lotteryId: string, collection: ICollectionReference) {
    super(lotteryId, collection);
    this._docReference = collection.doc(lotteryId);
  }

  public getFilters() {
    let filters = new DbCustomerLotteryFilters(this._docReference.collection("filters"));
    return filters;
  }

  
  public getFilterGroups() {
    let filters = new DbCustomerLotteryFilterGroups(this._docReference.collection("filter-groups"));
    return filters;
  }

  getFiltersParams() {
    let filters = new DbCustomerLotteryFiltersParams(this._docReference.collection("filter-params"));
    return filters;
  }



  getBets(): DbCustomerLotteryBets {
    return new DbCustomerLotteryBets(this._docReference.collection("bets"))
  }


  public getBet(betId: string): DbCustomerLotteryBet {


    let bet = new DbCustomerLotteryBet(betId, this._docReference.collection("bets"));

    return bet;
  }

  public getLab(labId: string): DbCustomerLotteryLab {


    let bet = new DbCustomerLotteryLab(labId, this._docReference.collection("labs"));

    return bet;
  }


}



